/* global angular */
angular.module('ua5App')
    // Grabs all costume data. For now, it's just pointed at a dummy JSON file
    // but ultimately it should be available on the server and accessible via
    // an API.
    .factory('Resource', ['$resource', '$rootScope', function($resource, $rootScope) {
        return {
            data: function(slug) {
                return $resource($rootScope.apiDevUrl + 'resource/' + slug);
            }
        };
    }])
    .factory('ResourceSections', ['$resource', function($resource) {
        return {
            data: function() {
                return $resource('data/resource-sections.json');
            }
        };
    }])
;
